import { type AxiosResponse } from "axios"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import { File as FileModel } from "@/models/file/file.model"
import { type IFile } from "@/interfaces/api/file.interface"

export class FileRepository {
  public uploadFile(file: File) {
    const formData = new FormData()
    formData.append("file", file)

    return new HTTPRequestBuilder(HTTPMethods.POST, "core/files/")
      .setData(formData)
      .setExpectedStatusCode(201)
      .setCloning(false) // Disable cloning because this is form data.
      .build()
      .execute()
  }

  public async rotate(file: FileModel, degrees: number): Promise<AxiosResponse<IFile>> {
    return await new HTTPRequestBuilder(HTTPMethods.PUT, `core/files/${file.id}/rotate/`)
      .setData({ degrees })
      .setExpectedStatusCode(200)
      .build()
      .execute()
  }

  public async modify(fileModel: FileModel, file: File): Promise<AxiosResponse<IFile>> {
    const formData = new FormData()
    formData.append("file", file)
    return await new HTTPRequestBuilder(HTTPMethods.PUT, `core/files/${fileModel.id}/modify/`)
      .setData(formData)
      .setCloning(false) // Disable cloning because this is form data.
      .setExpectedStatusCode(200)
      .build()
      .execute()
  }

  /**
   * UGLY FALLBACK METHOD, remove this when we fixed the CapacitorHttp issue on iOS.
   * @param file
   */
  public uploadFileBase64(file: File): Promise<AxiosResponse<IFile>> {
    return new Promise<AxiosResponse<IFile>>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = async (event) => {
        try {
          const base64Data = event.target?.result
          const response = await new HTTPRequestBuilder(HTTPMethods.POST, "core/files/")
            .setData({ file: base64Data })
            .setExpectedStatusCode(201)
            .build()
            .execute()
          resolve(response)
        } catch (fallbackError) {
          reject(fallbackError)
        }
      }
      reader.onerror = (err) => {
        reject(err)
      }
      reader.readAsDataURL(file)
    })
  }
}
